import { Container } from '@mui/material';
import { ReactNode } from 'react';

interface PageViewProps {
  children: ReactNode;
  testId?: string;
}

export const PageView = ({ children, testId }: PageViewProps) => (
  <Container
    data-testid={testId}
    maxWidth="xl"
    sx={{ flexGrow: 1, py: 3 }}
  >
    {children}
  </Container>
);
